import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe(
  "pk_test_51QVckaDhlVSsc9I7Mihu8BjCA3EUrSI2YO7xqTzAFpbYAYPFg1WtShJHQyUCyHGfwfBzNkVQfLceepD3F64YvN2100DwllD0B9"
);
